:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._delete-app-modal-root_ca2yv_7 {
  position: relative;
  z-index: 1719; }
